import { CommonError } from '../../types';
import { ContestParticipantActions } from './actions';
import { REGISTER_CONTEST_REQUEST, REGISTER_CONTEST_SUCCESS, REGISTER_CONTEST_FAILURE, FETCH_PARTICIPANT_BY_ID_FAILURE, FETCH_PARTICIPANT_BY_ID_REQUEST, FETCH_PARTICIPANT_BY_ID_SUCCESS, FETCH_PARTICIPANTS_BY_ID_FAILURE, FETCH_PARTICIPANTS_BY_ID_REQUEST, FETCH_PARTICIPANTS_BY_ID_SUCCESS, CANCEL_REGISTRATION_SUCCESS, CANCEL_REGISTRATION_REQUEST, CANCEL_REGISTRATION_FAILURE } from './constants';
import { ContestParticipant } from './types';

export interface ContestParticipantState {
    myContestParticipant: ContestParticipant;
    contestParticipants: ContestParticipant[];
    loading: boolean;
    error: CommonError | null;
}

const initialState: ContestParticipantState = {
    myContestParticipant: {
        contestId: 0,
        uid: '',
        initialBalance: 0,
        finalBalance: 0,
    },
    contestParticipants: [],
    loading: false,
    error: null,
};

export const contestParticipantReducer = (state = initialState, action: ContestParticipantActions): ContestParticipantState => {
    switch (action.type) {
        case REGISTER_CONTEST_REQUEST:
            return { ...state, loading: true, error: null };
        case REGISTER_CONTEST_SUCCESS:
            return {
                ...state,
                loading: false,          
                myContestParticipant: action.payload,
                contestParticipants: [...state.contestParticipants, action.payload]
            };
        case REGISTER_CONTEST_FAILURE:
            return { ...state, loading: false, error: null };
        case FETCH_PARTICIPANT_BY_ID_REQUEST:
            return { ...state, loading: true, error: null};
        case FETCH_PARTICIPANT_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                myContestParticipant: action.payload!
            };
        case FETCH_PARTICIPANT_BY_ID_FAILURE:
            return { ...state, loading: false, error: null };
        case FETCH_PARTICIPANTS_BY_ID_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_PARTICIPANTS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                contestParticipants: action.payload
            };
        case FETCH_PARTICIPANTS_BY_ID_FAILURE:
            return { ...state, loading: false, error: null };
        case CANCEL_REGISTRATION_REQUEST:
            return { ...state, loading: true, error: null };
        case CANCEL_REGISTRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                contestParticipants: state.contestParticipants.filter(
                    (item) => item.contestId !== state.myContestParticipant.contestId || item.uid !== state.myContestParticipant.uid
                ),
                
                myContestParticipant: {
                    contestId: 0,
                    uid: '',
                    initialBalance: 0,
                    finalBalance: 0,
                },
            };
        case CANCEL_REGISTRATION_FAILURE:
            return { ...state, loading: false, error: null };
        default:
            return state;
    }
};
